/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import CampaignModel from 'cio/models/campaign';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

interface WebhookSendSampleArgs {
  campaign: CampaignModel;
  analyticsSource?: string;
  onCloseModal?: () => unknown;
  onDataReceived?: () => unknown;
}

export default class WebhookSendSample extends Component<WebhookSendSampleArgs> {
  @tracked isShowingTestModal = false;

  get shouldShow() {
    return (
      this.args.campaign.isWebhookTriggered && (this.args.campaign.latestWebhookLog == null || this.isShowingTestModal)
    );
  }

  @action
  showTestModal() {
    this.isShowingTestModal = true;
  }

  @action
  closeTestModal() {
    this.isShowingTestModal = false;

    this.args.onCloseModal?.();
  }
}
